import React from 'react';
import ReactModal from 'react-modal';

import Aux from '../../../hoc/ReactAux/ReactAux';

import './modalDeleteAccount.scss';

export const ModalDeleteAccount = ({ closeModal, isOpen, onConfirm }) => {
  return (
    <Aux>
      <ReactModal
        isOpen={isOpen}
        shouldCloseOnOverlayClick={true}
        shouldCloseOnEsc={true}
        onRequestClose={closeModal}
        contentLabel="Delete Account"
        className="modal-delete"
        overlayClassName="modal-delete-overlay"
      >
        <div className="modal-delete-content">
          <h3>Delete Account</h3>
          <p>All your account information will be permanently deleted.</p>
          <div className="modal-delete-buttons">
            <button className="btn-cancel-delete" onClick={closeModal}>
              Cancel
            </button>
            <button className="btn-delete" onClick={onConfirm}>
              Delete
            </button>
          </div>
        </div>
      </ReactModal>
    </Aux>
  );
};



// WEBPACK FOOTER //
// ./src/components/UI/Modal/ModalDeleteAccount.js